/**
 * 결과 표의 열 고정 · 행 고정 (2026-10-01, 열 고정은 2026-10-02 「제자리 고정」으로 바꿈).
 *
 * - 열 고정: 머리글 우클릭 → 그 열을 **제자리에서** 세운다(sticky left). 순서를 바꾸지 않는다 — 예전에는 순번 칸
 *   바로 뒤로 옮겼는데, 고정한 열이 다른 자리로 튀어 「어디 갔나」 가 됐다(요청). 오른쪽으로 스크롤하면 그 열은
 *   왼쪽 끝(앞에 고정한 열들 다음)에 멈추고, 그 앞의 고정 안 한 열들은 그 밑으로 지나간다.
 * - 행 고정: 순번 칸 더블클릭 → 머리글 바로 아래에 그 행을 한 번 더 그려 세로로 스크롤해도 남긴다.
 *   본문의 그 행은 제자리에 둔다(어디 있던 행인지 잃지 않게).
 */

/** 순번 칸 너비 — ResultGrid 의 __rowNumber__ 고정 폭과 같아야 고정 열이 겹치지 않는다 */
export const ROW_NUMBER_WIDTH = 30;

/**
 * 고정 열마다 왼쪽에서 얼마나 떨어져 서는가(px) — **보이는 순서대로** 앞에 있는 고정 열 너비만 더한다.
 * @param displayKeys 보이는 열 키(순서대로, 순번 칸 제외)
 * @param pinned      고정한 열 키
 * @param widthOf     (key) => px
 * @param start       첫 고정 열이 설 자리(순번 칸 너비)
 * @returns {{ left: Object<string, number>, last: string|null }} last = 가장 오른쪽 고정 열(그림자를 그린다)
 */
export function pinnedLeftOffsets(displayKeys, pinned, widthOf, start = ROW_NUMBER_WIDTH) {
    const set = new Set(pinned || []);
    const left = {};
    let x = start;
    let last = null;
    for (const k of displayKeys || []) {
        if (!set.has(k)) continue;
        left[k] = x;
        x += widthOf(k) || 0;
        last = k;
    }
    return { left, last };
}

/** 열 목록이 바뀌면 없는 열의 고정은 버린다 — 바뀐 게 없으면 같은 배열 */
export function prunePinned(pinned, existingKeys) {
    const have = new Set(existingKeys || []);
    const next = (pinned || []).filter(k => have.has(k));
    return next.length === (pinned || []).length ? pinned : next;
}

/** 행 고정 켜고 끄기 — 고정한 순서를 지킨다 */
export function togglePinned(list, value) {
    const arr = Array.isArray(list) ? list : [];
    return arr.includes(value) ? arr.filter(v => v !== value) : [...arr, value];
}
